module.exports = __webpack_public_path__ + "media/images/game/bonus_tasks/audio_video-ff9fca72d8b491f5ab9b331ba0bda9b7.png";